module.exports = __webpack_public_path__ + "static/media/logo_light.c8614ac7.png";